const siteLayout = document.querySelector('body');

function openCart() {
    siteLayout.classList.add('wbs-cart-opened');
}

function closeCart() {
    siteLayout.classList.remove('wbs-cart-opened');
}

document.querySelector('.header-cart').addEventListener('click', function(event) {
    event.preventDefault();
    openCart();
});

function formatPrice(price) {
    price = price.toString().trim();
    price = price.replace(/^[£$€]/, '');

    let formattedPrice = parseFloat(price).toFixed(2);
    return `£${formattedPrice.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
}

function addVAT(price) {
    return price * 1.20;
}

function removeVAT(price) {
    return price / 1.20;
}

function handleRemoveItem(event) {
    const itemId = event.target.closest('.wbs-cart-item').getAttribute('data-item-id');

    fetch('/cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            updates: {
                [itemId]: 0,
            },
        }),
    })
    .then(response => response.json())
    .then(data => {
        if (data.status === 'ok') {
            renderCartItems();
        } else {
            console.error('Failed to remove item');
        }
    })
    .catch(error => {
        console.error('Error removing item from cart:', error);
    });
}

async function getCartItems() {
    return fetch('/cart.js').then(response => {
        if (!response.ok) {
            throw new Error('Failed to fetch cart data.');
        }
        return response.json();
    }).then(cart => {
        renderCart(cart);
    }).catch(error => {
        console.error('Error fetching cart:', error);
    });
}

function removeItemFromCart(itemId) {
    const formData = {
        id: itemId,
        quantity: 0
    };

    fetch('/cart/change.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
    }).then(response => {
        if (!response.ok) {
            throw new Error('Failed to remove item from cart.');
        }
        return response.json();
    }).then(cart => {
        getCartItems();
    }).catch(error => {
        console.error('Error removing item:', error);
    });
}

function getResizedImageUrl(imageUrl, width) {
    if (!imageUrl) return '';
    const newImageUrl = imageUrl.split('?')[0];
    return `${newImageUrl}?width=${width}`;
}

function quantityUpdate(itemId, quantity) {
    if (itemId) {
        fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                updates: {
                    [itemId]: quantity,
                }
            })
        })
        .then(response => response.json())
        .then(updatedCart => {
            getCartItems();
        })
        .catch(error => console.error('Error updating cart:', error));
    }
}

function attachQuantityListeners() {
    document.querySelectorAll('.cart-item-details .qtty').forEach(qttyDiv => {
        const input = qttyDiv.querySelector('input[name="qtty"]');

        const itemDiv = qttyDiv.closest('.wbs-cart-item');
        const itemId = itemDiv.getAttribute('data-id');

        qttyDiv.querySelector('.minus').addEventListener('click', () => {
            let currentValue = parseInt(input.value, 10) || 1;
            input.value = Math.max(1, currentValue - 1);

            quantityUpdate(itemId, input.value);
        });

        qttyDiv.querySelector('.plus').addEventListener('click', () => {
            let currentValue = parseInt(input.value, 10) || 1;
            input.value = currentValue + 1;

            quantityUpdate(itemId, input.value);
        });

        qttyDiv.querySelector('.cart-item-details input[name="qtty"]').addEventListener('change', function(event) {
            const quantity = event.target.value;
            quantityUpdate(itemId, quantity);
        });
    });
}

async function getVariant(variant_id) {
    try {
        const response = await fetch('https://app.wheeliebins.co.uk/get-variant.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(variant_id)
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('There was a problem with the fetch operation:', error);
        throw error;
    }
}

async function renderCart(cart) {
    const cartItemsContainer = document.querySelector('.wbs-cart-items');
    const cartTotalsContainer = document.querySelector('.wbs-cart-totals');
    const cartFloat = document.querySelector('.wbs-cart-float');

    cartItemsContainer.innerHTML = '';
    cartTotalsContainer.innerHTML = '';

    if (cart.items.length === 0) {
        cartFloat.style.display = 'none';

        cartItemsContainer.innerHTML = `
            <div class="wbs-cart-empty">
                <h3>Your basket is currently empty.</h3>
                <p>Looks like you haven't added anything to your basket yet. Start shopping to fill it up!</p>
                <a href="/collections/all" class="button">Browse Products</a>
            </div>`;

        if (document.querySelector('.wbs-cart-loader')) {
            removeLoader();
        }
    } else {
        let subtotal = 0;

        for (const item of cart.items) {
            let variant_data = '';
            
            let item_title = item.product_title;
            let item_image = item.image ? getResizedImageUrl(item.image, 150) : '';
            let item_price = item.final_line_price / 100;

            if (item.price == 0) {
                variant_data = await getVariant(item.variant_id);
                
                item_title = variant_data.title;
                item_image = variant_data.image ? getResizedImageUrl(variant_data.image, 150) : '';
                item_price = variant_data.price;
            }

            subtotal += parseFloat(item_price);

            const itemHtml = `
                <div class="wbs-cart-item" data-id="${item.id}">
                    <div class="cart-item-image">
                        <img src="${item_image}" alt="${item_title}" />
                    </div>
                    <div class="cart-item-details">
                        <div class="cart-item-left">
                            <h3 class="cart-item-title">${item_title}</h3>

                            <div class="cart-item-options">
                                ${item.properties && Object.keys(item.properties).length > 0
                                    ? Object.entries(item.properties).map(([key, value]) => 
                                        `<p class="item-property"><span>${key}:</span> ${value}</p>`).join('')
                                    : ''}
                            </div>

                            <div class="qtty">
                                <span class="minus">-</span>
                                <input type="text" name="qtty" value="${item.quantity}">
                                <span class="plus">+</span>
                            </div>
                        </div>
                        <div class="cart-item-right">
                            <p class="cart-item-price">${formatPrice(parseFloat(item_price))}</p>
                            <a href="#" class="cart-item-remove">Remove</a>
                        </div>
                    </div>
                </div>
            `;
            cartItemsContainer.innerHTML += itemHtml;
        }

        document.querySelectorAll('.cart-item-remove').forEach(button => {
            button.addEventListener('click', function(event) {
                event.preventDefault();
                showLoader();
                const itemId = this.closest('.wbs-cart-item').dataset.id;
                removeItemFromCart(itemId);
            });
        });

        console.log(subtotal);
        const total = addVAT(subtotal);
        console.log(total);
        const vat = total - subtotal;
        console.log(vat);

        const totalsHtml = `
            <table class="cart-totals-table">
                <tr>
                    <td><strong>Subtotal</strong></td>
                    <td>${formatPrice(subtotal)}</td>
                </tr>
                <tr>
                    <td><strong>VAT</strong></td>
                    <td>${formatPrice(vat)}</td>
                </tr>
                <tr>
                    <td><strong>Total</strong></td>
                    <td>${formatPrice(total)}</td>
                </tr>
            </table>
        `;
        cartTotalsContainer.innerHTML = totalsHtml;

        if (document.querySelector('.wbs-cart-loader')) {
            removeLoader();
        }

        attachQuantityListeners();
        cartFloat.style.display = 'block';
    }
}

function showLoader() {
    const loader = document.createElement('div');
    loader.classList.add('wbs-cart-loader');

    const innerLoader = document.createElement('div');
    innerLoader.classList.add('loader');

    loader.appendChild(innerLoader);

    const cartItemsContainer = document.querySelector('.wbs-cart-wrap');
    
    cartItemsContainer.appendChild(loader);

    document.querySelector('.wbs-cart-float').style.display = 'none';
}

function removeLoader() {
    document.querySelector('.wbs-cart-loader').remove();
}

function handleize(str) {
    return str
        .toLowerCase()
        .trim()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "")
        .replace("+", "");
}

$(document).ready(function() {
    getCartItems();
    
    var winWidth = $(window).width();

    if (winWidth < 1261) {
        $('.info.slides').slick({
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 2,
            autoplay: true,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }

    $('.mobile-icon').on('click', function() {
        $('.site-layout').toggleClass('menu-opened');
    });

    $('.site-menu ul li.simple-children > a').on('click', function(event) {
        event.preventDefault();
        
        if ($(this).parent().hasClass('open')) {
            $(this).parent().removeClass('open');
            $(this).parent().find('.jaydee-menu').slideUp();
        } else {
            $('.site-menu ul li.simple-children').removeClass('open');
            $(this).parent().addClass('open');
            $(this).parent().find('.jaydee-menu').slideDown();
        }
    });

    $('.footer p.footer-heading').on('click', function(event) {
        event.preventDefault();
        
        if ($(this).hasClass('submenu-open')) {
            $(this).removeClass('submenu-open');
            $(this).parent().find('.footer-menu').slideUp();
        } else {
            $('.footer p.footer-heading').removeClass('submenu-open');
            $(this).addClass('submenu-open');
            $(this).parent().find('.footer-menu').slideDown();
        }
    });

    $('.search-icon').on('click', function() {
        $('.header-search').toggleClass('visible');
    });

    $('.grid-children').hover(
        function() {
            const menu_slides = $(this).find('.menu-slides').attr('data-cols');
            $(this).find('.menu-slides').slick({
                infinite: true,
                slidesToShow: menu_slides,
                slidesToScroll: 1
            });
        },
        function() {
            $(this).find('.menu-slides').slick('unslick');
        }
    );

    $('.jaydee-grid-menu').each(function () {
        const cols = parseInt($(this).data('cols'), 10);

        if (cols < 3) {
            $(this).closest('.menu-item').addClass('grid-menu-cols');
        }
    });

    $('.wbs-cart-close, .wbs-cart-overlay').on('click', function(event) {
        event.preventDefault();

        closeCart();
    });

    function updateProductGridPrice() {
        $('.wb-grid-price').each(function(index, el) {
            if ($('input[name="header-switch"]').is(":checked")) {
                $(this).find('span').text(formatPrice(parseFloat($(this).find('span').attr('data-vat-price'))));
            } else {
                $(this).find('span').text(formatPrice(parseFloat($(this).find('span').attr('data-price'))));
            }
        });
    }

    function updateCollectionPrice() {
        $('.pprice').each(function(index, el) {
            var price = parseFloat($(this).find('span').attr('data-price'));

            if ($('input[name="header-switch"]').is(":checked")) {
                price = addVAT(price);
            } else {
                price = removeVAT(price);
            }

            $(this).find('span').attr('data-price', price);
            $(this).find('span').text(formatPrice(price));
        });
    }

    $('input[name="header-switch"]').on('change', function() {
        if ($(this).is(':checked')) {
            $('.vat-text').text('Inc. VAT');
        } else {
            $('.vat-text').text('Ex. VAT');
        }

        if ($('.wb-product-grid').length) {
            updateProductGridPrice();
        }

        if ($('.collection-section').length) {
            updateCollectionPrice();
        }

        if ($('.product-data').length) {
            $('input[name="vat-switch"]').prop("checked", $(this).is(":checked")).change();
        } else {
            $('.vat-switch').toggleClass('vat-active');
        }
    });
});